// extracted by mini-css-extract-plugin
export default {"leagueHeader":"SingleFixture_leagueHeader__uPzgF","separationLine":"SingleFixture_separationLine__A-5lS","fixtureInfoWrapper":"SingleFixture_fixtureInfoWrapper__drxu9"};